import type { SMSNotification } from '@packages/domain/models/smsNotification';
import { normalizeResponse } from '@packages/domain/utils/normalize/normalize';
import { schemas } from 'constants/schemas';
import type { SMSNotificationResponse } from 'services/payex/payments/types';

export const normalizeSmsNotifications = (
  smsNotification: SMSNotificationResponse,
): {
  entities: {
    smsNotification: Record<string, SMSNotification>;
  };
  result: string[];
} => normalizeResponse(smsNotification, schemas.smsNotification);
